import React, { useEffect } from 'react';

const Discord = () => {
  useEffect(() => {window.location.href = "https://discord.com/oauth2/authorize?client_id=1144747722944024596";}, []);
  return <div>Redirecting to external site...</div>;
};

export default Discord;
